
export const AGENT_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Agent Id",
    },
    {
        dataIndex: "agentCode",
        title: "Agent Code",
    },

    {
        dataIndex: "agentName",
        title: "Agent Name",
    },
    {
        dataIndex: "role",
        title: "Role",
    },
    {
        dataIndex: "associatedReligion",
        title: "Associated Religion",
    },
    {
        dataIndex: "attributes",
        title: "Attributes",
    },
    {
        dataIndex: "weightage",
        title: "Weightage",
    },
    {
        dataIndex: "assessmentFunction",
        title: "Assessment Function",
    },
    {
        dataIndex: "approvalAuthority",
        title: "Approval Authority",
    },
    {
        dataIndex: "tokenInfluenceRuleId",
        title: "Token Influence Rule Id",
    },
    {
        dataIndex: "parentAgentCode",
        title: "Parent Agent Code",
    },
];

export const VALUE_CHAIN_CATEGORY_COLUMN = [
    {
        dataIndex: "id",
        title: "Category Id",
    },
    {
        dataIndex: "name",
        title: "Category Name",
    },
    {
        dataIndex: "description",
        title: "Description",
    },
    {
        dataIndex: "dependentValueChainCategoryCode",
        title: "Dep ValueChain Category Code",
    },
];

export const VALUE_CHAIN_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Value Chain Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Value Chain Name",
    },
    {
        key: "categoryName",
        dataIndex: "categoryName",
        title: "Value Chain Category Name",
    },
    {
        key: "parameters",
        dataIndex: "parameters",
        title: "Parameters",
    },
    {
        key: "dependentValueChainCode",
        dataIndex: "dependentValueChainCode",
        title: "Dependent Value Chain Code",
    },
];

export const RESPONSIBILITY_GROUP_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Res Group Id",
    },
    {
        key: "groupName",
        dataIndex: "groupName",
        title: "Res Group Name",
    },
    {
        key: "description",
        dataIndex: "description",
        title: "Description",
    },
    {
        key: "religion",
        dataIndex: "religion",
        title: "Religion",
    },
    {
        key: "dependentRespGroupCode",
        dataIndex: "dependentRespGroupCode",
        title: "Dependent Resp Group Code",
    },
];

export const RESPONSIBILITY_CENTER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Res Center Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Res Center Name",
    },
    {
        key: "description",
        dataIndex: "description",
        title: "Description",
    },
    {
        key: "groupName",
        dataIndex: "groupName",
        title: "Res Group Name",
    },
    {
        key: "dependentRespCenterCode",
        dataIndex: "dependentRespCenterCode",
        title: "Dependent Resp Center Code",
    },
];

export const ORGANIZATION_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Organization Id",
    },
    {
        dataIndex: "name",
        title: "Organization Name",
    },
    {
        dataIndex: "code",
        title: "Organization Code",
    },
    {
        dataIndex: "contactPerson",
        title: "Contact Person",
    },
    {
        dataIndex: "contactEmail",
        title: "Contact Email",
    },
    {
        dataIndex: "contactPhone",
        title: "Contact Phone",
    },
    {
        dataIndex: "website",
        title: "Website",
    },
    {
        dataIndex: "city",
        title: "City",
    },
    {
        dataIndex: "stateId",
        title: "State Id",
    },
    {
        key: "state",
        dataIndex: ["state", "name"],
        title: "State Name",
    },
    {
        dataIndex: "countryId",
        title: "Country Id",
    },

    {
        key: "country",
        dataIndex: ["country", "name"],
        title: "Country name",
    },


    {
        dataIndex: "dependentOrgCode",
        title: "Dependent Organization Code",
    },
    {
        dataIndex: "organizationType",
        title: "Organization Type",
    },
    {
        dataIndex: "address",
        title: "Address",
    },
];

export const TOKEN_MECHANISM_MASTER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "id",
    },
    {
        dataIndex: "description",
        title: "Description",
    },
    {
        dataIndex: "effectiveFromDate",
        title: "Effective From Date",
    },
    {
        dataIndex: "effectiveToDate",
        title: "Effective To Date",
    },
    {
        dataIndex: "multiplier",
        title: "Multiplier",
    },
    {
        dataIndex: "currencyUnit",
        title: "Currency Unit",
    },
];


export const USER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "User Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Name",
    },
    {
        key: "mobileNo",
        dataIndex: "phoneNumber",
        title: "Mobile Number",
    },
    {
        key: "email",
        dataIndex: "email",
        title: "Email",
    },
    {
        key: "role",
        dataIndex: "userRole",
        title: "Subscriber",
    },
    {
        key: "group",
        dataIndex: "userGroup",
        title: "User Group",
    },
    // {
    //     key: "package",
    //     dataIndex: "packageMaster",
    //     title: "Package Name",
    // },
    // {
    //     key: "packageType",
    //     dataIndex: "packageType",
    //     title: "Package Type",
    // }
];

export const USER_SUBSCRIBER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Subscriber Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Subscriber Name",
    },
];

export const USER_GROUP_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "User Group Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "User Group Name",
    },
];

export const COUNTRY_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Country Id",
    },
    {
        key: "countryName",
        dataIndex: "name",
        title: "Country Name",
    },
];
export const STATE_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "State Id",
    },
    {
        key: "countryName",
        dataIndex: ["country", "name"],
        title: "Country Name",
    },
    {
        key: "stateName",
        dataIndex: "name",
        title: "State Name",
    },
];

export const MEMBER_CATEGORY_MASTER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Member Id",
    },
    {
        key: "memberCategoryName",
        dataIndex: "memberCategoryName",
        title: "Member Category Name",
    },
    {
        key: "description",
        dataIndex: "description",
        title: "Description",
    },
];


export const SCENARIO_MASTER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Scenario ID",
    },
    {
        key: "memberId",
        dataIndex: "memberId",
        title: "Member ID",
    },
    {
        key: "memberObj.memberName",
        dataIndex: ["memberObj", "memberName"],
        title: "Member Name",
    },
    {
        key: "scenarioType",
        dataIndex: "scenarioType",
        title: "Scenario Type",
    },
    {
        key: "description",
        dataIndex: "description",
        title: "Description",
    },
    {
        key: "religion",
        dataIndex: "religion",
        title: "Religion",
    },
    {
        key: "projectTag",
        dataIndex: "projectTag",
        title: "Project Tag",
    },
    {
        key: "intensityLevel",
        dataIndex: "intensityLevel",
        title: "Intensity Level",
    },

];


export const SCRIPTURAL_REFERENCE_MASTER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Reference ID",
    },
    {
        key: "religion",
        dataIndex: "religion",
        title: "Religion",
    },
    {
        key: "textSnippet",
        dataIndex: "textSnippet",
        title: "Text Snippet",
    },
    {
        key: "context",
        dataIndex: "context",
        title: "Context",
    },
    {
        key: "application",
        dataIndex: "application",
        title: "Application",
    },
];


export const MEMBER_MASTER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Member Id",
    },
    {
        key: "memberName",
        dataIndex: "memberName",
        title: "Member Name",
    },
    {
        key: "memberCategoryCode",
        dataIndex: "memberCategoryCode",
        title: "Member Category Code",
    },
    {
        key: "gender",
        dataIndex: "gender",
        title: "Gender",
    },
    {
        key: "dob",
        dataIndex: "dob",
        title: "Date of Birth",
    },
    {
        key: "contactInfo",
        dataIndex: "contactInfo",
        title: "Contact Information",
        render: (index: any, record: any) => {

            if (record.contactInfo == null) {
                return (
                    <div className="d-flex align-items-start">
                        -
                    </div>
                );
            } else
                return (
                    <div className="d-flex align-items-start">
                        {record.contactInfo}
                    </div>
                );
        }
    },
    {
        key: "dependentMemberId",
        dataIndex: "dependentMemberId",
        title: "Dependent Member Id",
        render: (index: any, record: any) => {

            if (record.dependentMemberId == null) {
                return (
                    <div className="d-flex align-items-start">
                        -
                    </div>
                );
            } else
                return (
                    <div className="d-flex align-items-start">
                        {record.dependentMemberId}
                    </div>
                );
        }
    },
];

export const ACCOUNT_CATEGORY_MASTER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Account Category ID",
    },
    {
        key: "accountCategoryName",
        dataIndex: "accountCategoryName",
        title: "Account Category Name",
    },

    {
        key: "accountTypeId",
        dataIndex: "accountTypeId",
        title: "Account Type Id",
    },
    {
        key: "accountType",
        dataIndex: ["accountType", "accountName"],
        title: "Account Type Name",
    },
    {
        key: "description",
        dataIndex: "description",
        title: "Description",
    },
    {
        key: "dependentAccountCategoryCode",
        dataIndex: "dependentAccountCategoryCode",
        title: "Dependent Account Category Code",
    }
];

export const ACCOUNT_MASTER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Account ID",
    },
    {
        key: "accountCategoryCode",
        dataIndex: "accountCategoryCode",
        title: "Account Category Code",
    },
    {
        key: "accountCategory.accountCategoryName",
        dataIndex: ["accountCategory", "accountCategoryName"],
        title: "Account Category Name",
    },
    {
        key: "accountName",
        dataIndex: "accountName",
        title: "Account Name",
    },
    {
        key: "description",
        dataIndex: "description",
        title: "Description",
    },
    {
        key: "dependentAccountCode",
        dataIndex: "dependentAccountCode",
        title: "Dependent Account Code",
    }
];

export const ACCOUNT_TYPE_MASTER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Account Type ID",
    },
    {
        key: "accountCode",
        dataIndex: "accountCode",
        title: "Account Type Code",
    },
    {
        key: "accountName",
        dataIndex: "accountName",
        title: "Account Type Name",
    },
    {
        key: "accountDescription",
        dataIndex: "accountDescription",
        title: "Description",
    },

];



export const VOUCHER_TYPE_MASTER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Voucher Type ID",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Voucher Type Name",
    },
    {
        key: "description",
        dataIndex: "description",
        title: "Description",
    },

];


export const VOUCHER_PARTICIPANT_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Participant ID",
    },
    {
        key: "voucherId",
        dataIndex: "voucherId",
        title: "Voucher ID",
    },
    {
        key: "VoucherParty",
        dataIndex: ["voucherFinance", "party"],
        title: "Voucher Party",
    },
    {
        key: "voucherAmount",
        dataIndex: ["voucherFinance", "amount"],
        title: "Voucher Amount",
    },
    {
        key: "voucherNarration",
        dataIndex: ["voucherFinance", "narration"],
        title: "Voucher Narration",
    },
    {
        key: "memberId",
        dataIndex: "memberId",
        title: "Member ID",
    },
    {
        key: "memberName",
        dataIndex: ["memberMaster", "memberName"],
        title: "Member Name",
    },
    {
        key: "memberCode",
        dataIndex: "memberCode",
        title: "Member Code",
    },

    {
        key: "role",
        dataIndex: "role",
        title: "Role",
    },
];



export const PARTY_CATEGORY_MASTER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "ID",
    },
    {
        key: "code",
        dataIndex: "code",
        title: "Code",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Name",
    },
    {
        key: "description",
        dataIndex: "description",
        title: "Description",
    }
];




export const VOUCHER_FINANCE_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "ID",
    },
    {
        key: "voucherTypeCode",
        dataIndex: "voucherTypeCode",
        title: "Voucher Type Code",
    },
    {
        key: "voucherTypeName",
        title: "Voucher Type Name",
        dataIndex: ["voucherTypeObj", "name"],
    },
    {
        key: "amount",
        dataIndex: "amount",
        title: "Amount",
    },

    {

        key: "party",
        title: "Party Name",
        dataIndex: "party",

    },
    {
        key: "partyCategoryId",
        dataIndex: "partyCategoryId",
        title: "party Category Id",
    },


    {
        key: "partyCategoryObj",
        title: "Party  Category Name",
        dataIndex: ["partyCategoryObj", "name"],
    },
    {
        key: "narration",
        dataIndex: "narration",
        title: "Narration",
    },
    {
        key: "creditAccount",
        dataIndex: ["creditAccount", "accountName"],
        title: "Account Name Credit",
    },

    {
        key: "debitAccount",
        dataIndex: ["debitAccount", "accountName"],
        title: "Account Name Credit",
    },
    {
        key: "approvalStatus",
        dataIndex: "approvalStatus",
        title: "Approval Status",
    },
    {
        key: "approvedBy",
        dataIndex: "approvedBy",
        title: "Approved By",
    },
    {
        key: "approvalDate",
        dataIndex: "approvalDate",
        title: "Approval Date",
    },
    {
        key: "parentVoucherCode",
        dataIndex: "parentVoucherCode",
        title: "Parent Voucher Code",
    },
    {
        key: "projectTag",
        dataIndex: "projectTag",
        title: "Project Tag",
    },
    {
        key: "googleDriveLink",
        dataIndex: "googleDriveLink",
        title: "Google Drive Link",
    },
];


export const VOUCHER_KARMA_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "ID",
    },
    {
        key: "voucherTypeCode",
        dataIndex: "voucherTypeCode",
        title: "Voucher Type Code",
    },
    {
        key: "voucherTypeName",
        title: "Voucher Type Name",
        dataIndex: ["voucherType", "name"],
    },
    {
        key: "scenarioCode",
        dataIndex: "scenarioCode",
        title: "Scenario Code",
    },
    {
        key: "scenarioId",
        dataIndex: "scenarioId",
        title: "Scenario ID",
    },
    {
        key: "scenarioType",
        title: "Scenario Type",
        dataIndex: ["scenario", "scenarioType"],
    },
    {
        key: "scenarioDescription",
        title: "Scenario Description",
        dataIndex: ["scenario", "description"],
    },
    {
        key: "accountCode",
        dataIndex: "accountCode",
        title: "Account Code",
    },

    {
        key: "accountId",
        dataIndex: "accountId",
        title: "Account Id",
    },
    {
        key: "accountName",
        title: "Account Name",
        dataIndex: ["account", "accountName"],
    },
    {
        key: "accountCategoryName",
        title: "Account Category",
        dataIndex: ["account", "accountCategory", "accountCategoryName"],
    },
    {
        key: "parentVoucherId",
        dataIndex: "parentVoucherId",
        title: "Parent Voucher ID",
    },
    {
        key: "partyCategoryObj",
        title: "Parent Voucher Name",
        dataIndex: ["parentVoucher", "partyCategoryObj", "name"],
    },
    {
        key: "debit",
        dataIndex: "debit",
        title: "Debit",
    },
    {
        key: "credit",
        dataIndex: "credit",
        title: "Credit",
    },
    {
        key: "tokenValue",
        dataIndex: "tokenValue",
        title: "Token Value",
    },
    {
        key: "agent",
        dataIndex: "agent",
        title: "Agent",
    },
    {
        key: "assessmentOutcome",
        dataIndex: "assessmentOutcome",
        title: "Assessment Outcome",
    },
    {
        key: "improvementSuggestion",
        dataIndex: "improvementSuggestion",
        title: "Improvement Suggestion",
    },
    {
        key: "aiConfidenceScore",
        dataIndex: "aiConfidenceScore",
        title: "AI Confidence Score",
    },
    {
        key: "scripturalReferenceCode",
        dataIndex: "scripturalReferenceCode",
        title: "Scriptural Reference Code",
    },
    {
        key: "scripturalReferenceId",
        dataIndex: "scripturalReferenceId",
        title: "Scriptural Reference Id",
    },
    {
        key: "scripturalReferenceText",
        title: "Scriptural Reference Text",
        dataIndex: ["scripturalReference", "textSnippet"],
    },
    {
        key: "scripturalReferenceContext",
        title: "Scriptural Reference Context",
        dataIndex: ["scripturalReference", "context"],
    },
    {
        key: "purposeCode",
        dataIndex: "purposeCode",
        title: "Purpose Code",
    },
    {
        key: "validityDate",
        dataIndex: "validityDate",
        title: "Validity Date",
    },
    {
        key: "projectTag",
        dataIndex: "projectTag",
        title: "Project Tag",
    },
    {
        key: "scriptureVerseName",
        dataIndex: "scriptureVerseName",
        title: "Scripture Verse Name",
    },
    {
        key: "verseExplanation",
        dataIndex: "verseExplanation",
        title: "Verse Explanation",
    },
];


export const OPENING_KARMA_COLUMNS = [
    {
        key: "id",
        dataIndex: "id",
        title: "Opening ID",
    },
    {
        key: "accountCode",
        dataIndex: "accountCode",
        title: "Account Code",
    },
    {
        key: "accountName",
        title: "Account Name",
        dataIndex: ["account", "accountName"],
    },
    {
        key: "tokenValue",
        dataIndex: "tokenValue",
        title: "Token Value",
    },
    {
        key: "asOfDate",
        dataIndex: "asOfDate",
        title: "As Of Date",
    },
    {
        key: "sourceType",
        dataIndex: "sourceType",
        title: "Source Type",
    },
];

export const OPENING_FINANCE_COLUMNS = [
    {
        key: "id",
        dataIndex: "id",
        title: "Opening ID",
    },
    {
        key: "accountCode",
        dataIndex: "accountCode",
        title: "Account Code",
    },
    {
        key: "accountName",
        title: "Account Name",
        dataIndex: ["account", "accountName"],
    },
    {
        key: "amount",
        dataIndex: "amount",
        title: "Amount",
    },
    {
        key: "asOfDate",
        dataIndex: "asOfDate",
        title: "As Of Date",
    },
    {
        key: "sourceType",
        dataIndex: "sourceType",
        title: "Source Type",
    },
];



export const INVENTORY_CATEGORY_MASTER_COLUMN = [
    {

        key: "id",
        dataIndex: "id",
        title: "Category Id",
    },
    {
        key: "inventoryCategoryName",
        dataIndex: "inventoryCategoryName",
        title: "Category Name",
    },
    {
        key: "description",
        dataIndex: "description",
        title: "Description",
    },

];


export const INVENTORY_ITEM_MASTER_COLUMN = [
    {

        key: "id",
        dataIndex: "id",
        title: "Item Id",
    },
    {
        key: "inventoryCategoryCode",
        dataIndex: "inventoryCategoryCode",
        title: "Category Code",
    },
    {
        key: "inventoryCategoryName",
        dataIndex: ["inventoryCategoryObj", "inventoryCategoryName"],
        title: "Category Name",
    },
    {
        key: "itemName",
        dataIndex: "itemName",
        title: "Item Name",
    },
    {
        key: "description",
        dataIndex: "description",
        title: "Description",
    },
    {
        key: "unit",
        dataIndex: "unit",
        title: "Unit",
    },
    {
        key: "rate",
        dataIndex: "rate",
        title: "Rate",
    },
    {
        key: "dependentItemCategoryCode",
        dataIndex: "dependentItemCategoryCode",
        title: "Dependent Category Code",
    },
];


export const INVENTORY_OPENING_BALANCE_COLUMN = [
    {

        key: "id",
        dataIndex: "id",
        title: "OB ID",
    },
    {
        key: "itemCode",
        dataIndex: "itemCode",
        title: "Inventory Item Code",
    },
    {
        key: "itemName",
        dataIndex: ["itemObj", "itemName"],
        title: "Inventory Item Name",
    },

    {
        key: "quantity",
        dataIndex: "quantity",
        title: "Quantity",
    },
    {
        key: "asOfDate",
        dataIndex: "asOfDate",
        title: "As Of Date",
    },
];



export const INVENTORY_TRANSACTIONS_COLUMN = [
    {

        key: "id",
        dataIndex: "id",
        title: "Transaction ID",
    },
    {
        key: "itemCode",
        dataIndex: "itemCode",
        title: "Inventory Item Code",
    },
    {
        key: "itemName",
        dataIndex: ["itemObj", "itemName"],
        title: "Inventory Item Name",
    },

    {
        key: "date",
        dataIndex: "date",
        title: "Transaction Date",
    },
    {
        key: "qtyIn",
        dataIndex: "qtyIn",
        title: "Quantity In",
    },
    {
        key: "qtyOut",
        dataIndex: "qtyOut",
        title: "Quantity Out",
    },
    {
        key: "relatedVoucherID",
        dataIndex: "relatedVoucherID",
        title: "Related Voucher ID",
    },

    {
        key: "relatedVoucherObj",
        dataIndex: ["relatedVoucherObj", "party"],
        title: "Voucher Party",
    },

];

export const AI_PROCESSING_LOG_COLUMNS = [
    {
        key: "id",
        dataIndex: "id",
        title: "Log ID",
    },
    {
        key: "voucherId",
        dataIndex: "voucherId",
        title: "Voucher ID",
    },

    {
        key: "voucherObj",
        dataIndex: ["voucherObj", "party"],
        title: "Voucher Party",
    },
    {
        key: "modelVersion",
        dataIndex: "modelVersion",
        title: "Model Version",
    },
    {
        key: "confidenceScore",
        dataIndex: "confidenceScore",
        title: "Confidence Score",
    },
    {
        key: "processingNotes",
        dataIndex: "processingNotes",
        title: "Processing Notes",
    },

];

export const AUDIT_LOG_COLUMNS = [
    {
        key: "id",
        dataIndex: "id",
        title: "Audit ID",
    },
    {
        key: "tableName",
        dataIndex: "tableName",
        title: "Table Name",
    },
    {
        key: "recordId",
        dataIndex: "recordId",
        title: "Record ID",
    },
    {
        key: "operationType",
        dataIndex: "operationType",
        title: "Operation Type",
    },
    {
        key: "oldValue",
        dataIndex: "oldValue",
        title: "Old Value",
        render: (value: any) =>
            value && Object.keys(value).length > 0 ? (
                <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>
                    {JSON.stringify(value, null, 2)}
                </pre>
            ) : (
                "-"
            ),
    },
    {
        key: "newValue",
        dataIndex: "newValue",
        title: "New Value",
        render: (value: any) =>
            value && Object.keys(value).length > 0 ? (
                <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>
                    {JSON.stringify(value, null, 2)}
                </pre>
            ) : (
                "-"
            ),
    },

];


export const getLedgerColumns = (onAccountClick: (record: any) => void) => [
    {
        title: "ID",
        dataIndex: "id",
        key: "id",
    },
    {
        title: "Account Category",
        dataIndex: "accountCategory",
        key: "accountCategory",

    },
    {
        title: "Account Name",
        dataIndex: "accountName",
        key: "accountName",
        render: (text: string, record: any) => (
            <a style={{ color: "blue" }} onClick={() => onAccountClick(record)}>{text}</a>
        ),
    },
    {
        title: "Opening Balance",
        dataIndex: "openingBalance",
        key: "openingBalance",
    },
    {
        title: "Debit",
        dataIndex: "debit",
        key: "debit",
    },
    {
        title: "Credit",
        dataIndex: "credit",
        key: "credit",
    },
    {
        title: "Closing Balance",
        dataIndex: "closingBalance",
        key: "closingBalance",
    },
];








